import LocationVisitsFilter from "./location-visits-filter";


export default LocationVisitsFilter;